import {
	HttpInterceptor,
} from 'utils/http';
import {
	getSessionId,
} from 'utils/logrocket';

export const xCorrelationIdInterceptor: HttpInterceptor<RequestInit> =
	async (url: string, request: RequestInit): Promise<RequestInit> => ({
		...request,
		headers: {
			...request.headers,
			'X-Correlation-Id': `TC_APP_${getSessionId()}`,
		},
	});